/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
/**
 * Maps over an object's values, returning a new object with the same keys
 * but transformed values.
 */
function mapObject(obj, fn) {
    return Object.fromEntries(Object.entries(obj).map(([key, value]) => [key, fn(value, key)]));
}

export { mapObject };
//# sourceMappingURL=utils.js.map
